
import Interface from '../../lib'
const user = {
    state: {
        isLogin: false,
        userInfo: null,  // 用户信息
        cardInfo: null,  // 当前健康卡信息
        userName: null,
        sex: null,
        sexId: null,
        domicilePlace: null,
        id: null,
        idCard: null,
        mobileNumber: null,
        residence: null,
        isReload:true

    },
    mutations: {
        setIsLogin(state, data){
            state.isLogin = data;
        },
        // 用户信息
        setUserInfo(state, data){
            state.userInfo = data;
        },
        setReload(state,data){

            state.isReload=data
        },
        // 健康卡信息
        setCardInfo(state, data){
            state.cardInfo = data;
            if (data) {
                sessionStorage.setItem("hisCardInfo",  JSON.stringify(data));
            } else {
                sessionStorage.setItem("hisCardInfo",  'null');
            }
        },
        setUserName(state, data){
            state.userName = data;
        },
        setSex(state, data){
            state.sex = data;
        },
        setSexId(state, data){
            state.sexId = data;
        },
        setDomicilePlace(state, data){
            state.domicilePlace = data;
        },
        setId(state, data){
            state.id = data;
        },
        setIdCard(state, data){
            state.idCard = data;
        },
        setMmobileNumber(state, data){
            state.mobileNumber = data;
        },
        setResidence(state, data){
            state.residence = data;
        }
    },
    actions: {
        loginInfo({ commit, state }){
            return new Promise((resolve,reject)=>{
                Interface.pma.my.GetSessionId().then(res => {
                    Interface.pma.my.QueryUser(res.data).then(res => {
                        let data = res.data.data
                        sessionStorage.setItem("userInfo", JSON.stringify(data));  //添加到sessionStorage
                        sessionStorage.setItem("isLogin", true);  //添加到sessionStorage
                        
                        const returnUrl=localStorage.getItem('returnUrl')
                        if(returnUrl){
                            localStorage.setItem('userId',data.Id)
                            localStorage.removeItem("returnUrl")
                            location.href=returnUrl.replace("#/App/Home","") + "&auth=true"
                        }
                        Interface.pma.my.GetBindHealthCard(data.Id).then(res => {
                            if (res.data.code == 200) {
                                if ( res.data.data.length > 0) {
                                    let cardList = res.data.data;
                                    let cardInfo = cardList.filter(e=>e.Activated);
                                    if(cardInfo.length!==1){
                                        const params={
                                            UserId:cardList[0].UserId,
                                            healthCardId:cardList[0].Id
                                        }
                                        Interface.pma.my.SetDefaultCard(params).then(doc=>{
                                    commit('setCardInfo', doc.data.data)
                                    resolve(doc.data.data)
                                        })
                                    }else{
                                        commit('setCardInfo', cardInfo[0])
                                        resolve(cardInfo[0])
                                    }
                                } else {
                                    commit('setCardInfo', null)
                                    reject("无数据")
                                }
                            }
                        }).catch(err => {
                            commit('setCardInfo', null)
                        });

                        commit('setIsLogin', true)
                        commit('setUserInfo', data)
                        commit('setUserName', data.UserName)
                        commit('setSex', data.Sex)
                        commit('setSexId', data.SexId)
                        commit('setDomicilePlace', data.DomicilePlace)
                        commit('setId', data.Id)
                        commit('setIdCard', data.IdCard)
                        commit('setMmobileNumber', data.MobileNumber)
                        commit('setResidence', data.Residence)
                    });
                }).catch(err => {
                    reject("无数据")
                });
            })
        },
        getInfo({ commit, state }){
            let data = JSON.parse(sessionStorage.getItem("userInfo"))
            commit('setUserInfo', data)
            commit('setUserName', data.UserName)
            commit('setSex', data.Sex)
            commit('setSexId', data.SexId)
            commit('setDomicilePlace', data.DomicilePlace)
            commit('setId', data.Id)
            commit('setIdCard', data.IdCard)
            commit('setMmobileNumber', data.MobileNumber)
            commit('setResidence', data.Residence)

            Interface.pma.my.GetBindHealthCard(data.Id).then(res => {
                if (res.data.code == 200) {
                    if ( res.data.data.length > 0) {
                        let cardList = res.data.data;
                        let cardInfo = cardList.filter(e=>e.Activated);
                        if(cardInfo.length>1){
                            const params={
                                UserId:cardInfo[0].UserId,
                                healthCardId:cardInfo[0].Id
                            }
                            Interface.pma.my.SetDefaultCard(params).then(doc=>{
                        commit('setCardInfo', doc.data.data)
                            })
                        }else{
                            commit('setCardInfo', cardInfo[0])
                        }
                        // sessionStorage.setItem("hisCardInfo", JSON.stringify(cardInfo));  //添加到sessionStorage
                    } else {
                        // sessionStorage.setItem("hisCardInfo", '');  //添加到sessionStorage
                        commit('setCardInfo', null)
                    }
                }
            }).catch(err => {
                commit('setCardInfo', null)
            });
        }
    }

}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js